/**
 * Contact initials for the gold-pale circle avatar used on contact cards
 * and the Schedule view's assignee stack.
 *
 *   "Diego Ruiz" → "DR"
 *   "Cher"       → "C"
 *   ""           → "?"
 */
export function contactInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
  return (parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)).toUpperCase();
}
